import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { environment } from "src/environments/environment";
import { ApiResult } from "../models/api-result.model";
import { ObAccountAuthRequest } from "../models/ob-account-auth.request";
import { ObAccountAuthResponse } from "../models/ob-account-auth.response";
import { ObAccountModel, ObSelectAccountResponse } from "../models/ob-account.model";
import { ObAffordabilityModel } from "../models/ob-affordability.model";
import { ObInstitutionModel } from "../models/ob-institution.model";
import { CreatePaymentRequest, CreatePaymentResponse, ObPaymentAuthResponse, ObPaymentAuthUrlRequest } from "../models/ob-payment.model";
import { checkStatus } from "../util/check-status";

@Injectable({
  providedIn: 'root'
})
export class OpenBankingApi {
  constructor(private http: HttpClient) { }

  private httpGet<T>(path: string) {
    return this.http.get<ApiResult<T>>(environment.openBankingUrl + path)
      .pipe(checkStatus());
  }

  private httpGetAsync<T>(path: string) {
    return firstValueFrom(this.httpGet<T>(path));
  }

  private httpPost<T>(path: string, request: any) {
    return this.http.post<ApiResult<T>>(environment.openBankingUrl + path, request)
      .pipe(checkStatus());
  }

  private httpPostAsync<T>(path: string, request: any) {
    return firstValueFrom(this.httpPost<T>(path, request));
  }

  obInstitutions$() {
    return this.httpGet<ObInstitutionModel[]>(`/api/v1/institution/list`);
  }

  async obAccounts(consent: string, institutionId: number) {
    return await this.httpGetAsync<ObAccountModel>(`/api/v1/account/list?consent=${consent}&institutionId=${institutionId}`);
  }

  obAccountAuthUrl(request: ObAccountAuthRequest) {
    return this.httpPostAsync<ObAccountAuthResponse>(`/api/v1/account/authUrl`, request);
  }

  obGetCategories(accountId: number, consent: string) {
    return this.httpGetAsync<ObSelectAccountResponse>(`/api/v1/categorize/getCategories?accountId=${accountId}&consent=${consent}`);
  }

  obGetTransactions(accountId: number, consent: string) {
    return this.httpGetAsync<ObSelectAccountResponse>(`/api/v1/transaction/list?accountId=${accountId}&consent=${consent}`);
  }

  async obGetAffordability(accountId: number, consent: string, premium: number) {
    return await this.httpPostAsync<ObAffordabilityModel[]>(`/api/v1/affordability/days`, { accountId, consent, premium });
  }

  obPaymentAuthUrl(request: ObPaymentAuthUrlRequest) {
    return this.httpPostAsync<ObPaymentAuthResponse>(`/api/v1/payment/authUrl`, request);
  }

  obPayment(request: CreatePaymentRequest) {
    return this.httpPostAsync<CreatePaymentResponse>(`/api/v1/payment/pay`, request);
  }
}
